import React, { useRef, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import usePrevious from "@src/Hooks/usePrevious";
// import { LENGTH_CHECK } from "@utils/constants";
// import EditableContainer from "@common/EditableContainer";

function OtpInpuBox(props) {
  // const { isAlphanumeric, focus, autoFocus, value, otpValue, handlePasteValue, ...rest } = props;
  const { focus, autoFocus, ...rest } = props;

  const inputRef = useRef();
  const prevFocus = usePrevious(!!focus);
  
  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  
  // useEffect(()=>{
  //   const currentValue = inputRef?.current?.innerHTML;
  //   if(currentValue !== value){
  //     inputRef.current.innerHTML = value;
  //   }
  // },[value])

  // useEffect(()=>{
  //   if (otpValue.length === LENGTH_CHECK.OTP) {
  //     inputRef.current.blur();
  //   }
  // },[otpValue])
//  return <EditableContainer isAlphanumeric={isAlphanumeric ? isAlphanumeric : false} handlePasteValue={handlePasteValue} inputRef={inputRef} inputMode={!isAlphanumeric && "decimal"} {...rest} value={value} />
  return <input ref={inputRef} {...rest} />;
}

export default OtpInpuBox;

OtpInpuBox.propTypes = {
  focus: PropTypes.bool,
  autoFocus: PropTypes.bool,
  handlePasteValue: PropTypes.func
};
